import { useEffect } from "react";
import "../styles/mtw.css";

const roles = [
  { name: "Data Scientists", eng: true },
  { name: "QA Engineers", eng: true },
  { name: "Backend Engineers", eng: true },
  { name: "Frontend Engineers", eng: true },
  { name: "Fullstack Engineers", eng: true },
  { name: "Data Engineers", eng: true },
  { name: "GenAI Engineers", eng: true },
  { name: "DevOps Engineers", eng: true },
  { name: "Growth Managers", eng: false },
  { name: "Tech Sales Managers", eng: false },
  { name: "Founder's Office Associates", eng: false },
  { name: "Product Managers", eng: false },
];

const metrics = [
  {
    value: "26,000+",
    label: "Candidates",
  },
  {
    value: "6,500+",
    label: "AI Interviews",
  },
  {
    value: "700+",
    label: "Human Interviews @ MTW",
  },
  {
    value: "~100",
    label: "Expected Offers 🎉",
  },
];

const MTW = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll(".mtw-fade").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="mtw-root">
      <div className="mtw-page-body">
        {/* ── Hero Section ────────────────────────────────────────── */}
        <section className="mtw-section mtw-roles-bg" style={{ paddingTop: 80, paddingBottom: 80 }}>
          <div className="mtw-container">
            <div className="mtw-section-header mtw-fade" style={{ textAlign: "center" }}>
              <h1 style={{ fontSize: "48px", marginBottom: 20, fontWeight: 700 }}>
                🎉 India's First <span style={{ color: "var(--mtw-yellow)" }}>Agentic-AI Led</span> Job Fair
              </h1>
              <p className="mtw-section-sub" style={{ color: "rgba(255,255,255,0.85)", fontWeight: 400, fontSize: 18, maxWidth: 700, margin: "0 auto", lineHeight: 1.6 }}>
                The MTW 2026 AI Job Fair in collaboration with Babblebots showed how AI is changing recruitment for good! And at scale!
              </p>
              <p style={{ color: "rgba(255,255,255,0.6)", fontWeight: 400, fontSize: 14, maxWidth: 700, margin: "24px auto 0", lineHeight: 1.6 }}>
                Event Date: 29-30 May 2026
              </p>
            </div>
          </div>
        </section>

        {/* ── Impact Metrics ────────────────────────────────────────── */}
        <section className="mtw-section" style={{ paddingTop: 60, paddingBottom: 60 }}>
          <div className="mtw-container">
            <div className="mtw-fade" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 24 }}>
              {metrics.map((metric, idx) => {
                const colors = ["var(--mtw-cyan)", "var(--mtw-yellow)", "var(--mtw-pink)", "#6366f1"];
                return (
                  <div
                    key={idx}
                    style={{
                      padding: "52px 44px",
                      borderRadius: 12,
                      border: `2px solid ${colors[idx]}`,
                      background: "rgba(255,255,255,0.03)",
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      minHeight: 200,
                    }}
                  >
                    <div style={{ fontSize: 50, fontWeight: 700, color: colors[idx] }}>
                      {metric.value}
                    </div>
                    <div style={{ fontSize: 16, color: "rgba(255,255,255,0.75)", fontWeight: 500, lineHeight: 1.5 }}>
                      {metric.label}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── Event Gallery ────────────────────────────────────────── */}
        <section className="mtw-section" style={{ paddingTop: 60, paddingBottom: 60, background: "linear-gradient(180deg, rgba(255,255,255,0.02) 0%, transparent 100%)" }}>
          <div className="mtw-container">
            <div className="mtw-section-header mtw-fade" style={{ textAlign: "center", marginBottom: 60 }}>
              <h2 className="mtw-section-title">Moments from MTW Job Fair 2026</h2>
              <p className="mtw-section-sub">Real stories from the AI Job Fair</p>
            </div>

            <div
              className="mtw-fade"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: 24,
              }}
            >
              {[
                "/images/mtw/event-1.jpg",
                "/images/mtw/event-2.jpg",
                "/images/mtw/event-3.jpg",
                "/images/mtw/event-4.jpg",
                "/images/mtw/event-5.jpg",
                "/images/mtw/event-6.jpg",
              ].map((src, idx) => (
                <div
                  key={idx}
                  style={{
                    aspectRatio: "4/3",
                    borderRadius: 12,
                    border: "1px solid var(--mtw-border)",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={src}
                    alt={`Event moment ${idx + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Participating Companies ────────────────────────────────── */}
        <section className="mtw-section" style={{ paddingTop: 60, paddingBottom: 60, background: "linear-gradient(180deg, transparent 0%, rgba(255,255,255,0.02) 100%)" }}>
          <div className="mtw-container">
            <div className="mtw-section-header mtw-fade" style={{ textAlign: "center", marginBottom: 60 }}>
              <h2 className="mtw-section-title">Trusted by India's Top Companies</h2>
              <p className="mtw-section-sub">20+ leading companies across tech, fintech, e-commerce & more</p>
            </div>

            <div className="mtw-fade" style={{ display: "flex", justifyContent: "center" }}>
              <img
                src="/images/mtw/companies.png"
                alt="Participating companies at MTW AI Job Fair 2026"
                style={{
                  width: "100%",
                  maxWidth: 1000,
                  height: "auto",
                  borderRadius: 12,
                }}
              />
            </div>
          </div>
        </section>

        {/* ── Roles Filled ────────────────────────────────────────── */}
        <section className="mtw-section" style={{ paddingTop: 60, paddingBottom: 60 }}>
          <div className="mtw-container">
            <div className="mtw-section-header mtw-fade" style={{ textAlign: "center", marginBottom: 32 }}>
              <h2 className="mtw-section-title">Roles Filled at the Fair</h2>
              <p className="mtw-section-sub">Across engineering, data, product, growth & more</p>
            </div>

            {/* Legend */}
            <div className="mtw-fade" style={{ display: "flex", justifyContent: "center", gap: 28, marginBottom: 40, flexWrap: "wrap" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ width: 12, height: 12, borderRadius: "50%", background: "var(--mtw-cyan)" }} />
                <span style={{ fontSize: 14, color: "rgba(255,255,255,0.75)", fontWeight: 500 }}>Engineering & Data</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ width: 12, height: 12, borderRadius: "50%", background: "var(--mtw-pink)" }} />
                <span style={{ fontSize: 14, color: "rgba(255,255,255,0.75)", fontWeight: 500 }}>Business & Product</span>
              </div>
            </div>

            <div
              className="mtw-fade"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: 24,
              }}
            >
              {roles.map((role) => {
                const accent = role.eng ? "var(--mtw-cyan)" : "var(--mtw-pink)";
                return (
                  <div
                    key={role.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 24,
                      borderRadius: 12,
                      border: `1px solid ${accent}40`,
                      background: "rgba(255,255,255,0.04)",
                      fontSize: 14,
                      fontWeight: 600,
                      color: accent,
                      textAlign: "center",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "var(--mtw-card)";
                      e.currentTarget.style.borderColor = accent;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "rgba(255,255,255,0.04)";
                      e.currentTarget.style.borderColor = `${accent}40`;
                    }}
                  >
                    {role.name}
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── CTA Section ────────────────────────────────────────── */}
        <section className="mtw-section mtw-form-bg" style={{ textAlign: "center", paddingTop: 80, paddingBottom: 80 }}>
          <div className="mtw-container mtw-fade">
            <h2 className="mtw-section-title" style={{ marginBottom: 20 }}>
              Be Part of the Next Event
            </h2>
            <p className="mtw-section-sub" style={{ marginBottom: 40, color: "rgba(255,255,255,0.8)" }}>
              India's first Agentic-AI led Job Fair will return with more companies, more opportunities, and more success stories.
            </p>
            <a
              href="mailto:helpme@babblebots.ai?subject=Interest in Next MTW Job Fair"
              style={{
                display: "inline-block",
                padding: "14px 40px",
                background: "var(--mtw-pink)",
                color: "white",
                borderRadius: 8,
                fontWeight: 600,
                fontSize: 16,
                border: "none",
                cursor: "pointer",
                textDecoration: "none",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = "0 8px 24px rgba(233, 30, 140, 0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              Get Notified for Next Event →
            </a>
          </div>
        </section>

      </div>
    </div>
  );
};

export default MTW;
